export default __webpack_public_path__ + "static/media/facebook.f0fd597d.svg";